import * as React from "react";
import "./ColorSelect.component.css";
import Select from "react-select";
import { LabelledElement } from "../labelled-element/LabelledElement.component";
import { getReactSelectStyleClasses } from "../../style/style-functions";
import { useEffect, useState } from "react";
import { predefinedColorsLabelled } from "../../style/predefined-colors";
import { ColorInput } from "../color-input/ColorInput.component";
import { ColorSelectOption } from "./color-select-option/ColorSelectOption.component";
import { useTranslation } from "react-i18next";
export function ColorSelect({ label, color, disabled, onColorChanged }) {
    const [currentColor, setCurrentColor] = useState(undefined);
    const [currentCustomColor, setCurrentCustomColor] = useState(undefined);
    const [colorOptions, setColorOptions] = useState([]);
    const { t } = useTranslation();
    useEffect(() => {
        setColorOptions(predefinedColorsLabelled.map((c) => ({ value: c.value, label: c.label })));
    }, []);
    useEffect(() => {
        if (predefinedColorsLabelled.find((c) => c.value === color)) {
            setCurrentColor(color);
        }
        else {
            setCurrentCustomColor(color);
        }
    }, [color]);
    useEffect(() => {
        if (currentColor) {
            onColorChanged(currentColor);
        }
        else if (currentCustomColor) {
            setCurrentColor(currentCustomColor);
        }
    }, [currentColor]);
    useEffect(() => {
        if (currentCustomColor) {
            setCurrentColor(currentCustomColor);
            setColorOptions((prev) => {
                const options = [...prev];
                const customOption = options.find((o) => o.custom === true);
                if (customOption) {
                    customOption.value = currentCustomColor;
                }
                else {
                    options.push({ value: currentCustomColor, label: t("common:color-select-option-custom", "Custom"), custom: true });
                }
                return options;
            });
        }
    }, [currentCustomColor]);
    const getCurrentColorOption = () => {
        const predefined = predefinedColorsLabelled.find((c) => c.value === currentColor);
        if (predefined) {
            return colorOptions.find((c) => c.value === predefined.value);
        }
        else if (currentColor) {
            return colorOptions.find((c) => c.custom === true);
        }
        return undefined;
    };
    const onSelectedColorChanged = (option) => {
        if (option.custom) {
            setCurrentColor(currentCustomColor);
        }
        else {
            setCurrentColor(option.value);
        }
    };
    return (React.createElement(LabelledElement, { label: label },
        React.createElement("div", { className: "color-select-container" },
            React.createElement(Select, { components: { Option: ColorSelectOption }, onChange: (option) => {
                    onSelectedColorChanged(option);
                }, value: getCurrentColorOption(), options: colorOptions, classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body, isDisabled: disabled }),
            React.createElement(ColorInput, { color: currentColor !== null && currentColor !== void 0 ? currentColor : "#000000", disabled: disabled, onColorChanged: (color) => {
                    setCurrentCustomColor(color);
                } }))));
}
